import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-rat-errormsg',
  templateUrl: './rat-errormsg.component.html',
  styleUrls: ['./rat-errormsg.component.css']
})
export class RatErrormsgComponent implements OnInit {

  @Input() question!: any;
  @Input() eachControl!: any;
  @Input() controlIndex!: any;
  @Input() form!: FormGroup;
  @Input() isSubmitted!: boolean;
  @Input() isValid!: boolean;

  errorType: string | undefined;
  errorMsg: string | undefined;
  isArabic: any;
  constructor(private storageService: StorageService) { }
  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.form.get(this.question.quesId + '_id_' + this.controlIndex)?.valueChanges.subscribe(formValue => {
      // console.log('errormsg ngoninit');
      this.validateField();
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    // console.log('simple changes: ',changes);
    if (changes['isValid']?.currentValue == false) {
      this.validateField();
    }
  }
  validateField() {
    //  console.log('validate value changed', this.form?.controls[this.question?.quesId+'_id_'+this.controlIndex]?.errors);
    //  console.log('inside validate field', this.question?.quesId+'_id_'+this.controlIndex);
    const errors = this.form?.controls[this.question?.quesId + '_id_' + this.controlIndex]?.errors;
    //  console.log('inside validate field error: ', this.form?.controls[this.question?.quesId+'_id_'+this.controlIndex]?.errors);
    // console.log('inside validate field this.form: ', this.form);
    if (!!errors) {
      this.errorType = Object.keys(errors)[0];

      if (!!this.errorType) {
        if (this.eachControl?.validation) {
          this.errorMsg = this.isArabic ? this.eachControl?.validation[this.errorType]?.errorMsgArabic
            : this.eachControl?.validation[this.errorType]?.errorMsg;
          // console.log('this.errorMsg: ',this.errorMsg);
        } else {
          //  console.log('this.errorType: ',this.errorType);
        }

      }
    }
  }
}
